import { render } from "./FaqAccordion.vue?vue&type=template&id=9472a78c&scoped=true"
import script from "./FaqAccordion.vue?vue&type=script&lang=js"
export * from "./FaqAccordion.vue?vue&type=script&lang=js"

import "./FaqAccordion.vue?vue&type=style&index=0&id=9472a78c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9472a78c"]])

export default __exports__